/**
 * Generates an array of visible page numbers for pagination.
 *
 * @param {number} current - The current page number.
 * @param {number} total - The total number of pages.
 * @param {number} visibleCount - The number of visible pages in the pagination.
 * @returns {number[]} An array of visible page numbers.
 *
 * @example
 * // Example 1: Basic usage
 * // Current page is 5, total pages are 10, and we want to show 5 visible pages.
 * getVisiblePages(5, 10, 5);
 * // Returns: [3, 4, 5, 6, 7]
 *
 * @example
 * // Example 2: Current page is near the start
 * // Current page is 2, total pages are 10, and we want to show 5 visible pages.
 * getVisiblePages(2, 10, 5);
 * // Returns: [1, 2, 3, 4, 5]
 *
 * @example
 * // Example 3: Current page is near the end
 * // Current page is 9, total pages are 10, and we want to show 5 visible pages.
 * getVisiblePages(9, 10, 5);
 * // Returns: [6, 7, 8, 9, 10]
 */
export const getVisiblePages = (
    current: number,
    total: number,
    visibleCount: number,
) => {
    let start = Math.max(1, current - Math.floor(visibleCount / 2));
    const end = Math.min(total, start + visibleCount - 1);

    if (end - start < visibleCount - 1) {
        start = Math.max(1, end - visibleCount + 1);
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};
